import { FaBullseye, FaEye, FaLightbulb } from "react-icons/fa";
export const items = [
  {
    title: "MISSION",
    desc: "Deliver innovative software solutions that empower business growth.",
    icon: <FaBullseye className="w-16 h-16 text-white" />,
    gradient: "from-blue-500 to-cyan-500",
  },
  {
    title: "VISION",
    desc: "Become a trusted partner for future-ready technology solutions.",
    icon: <FaEye className="w-16 h-16 text-white" />,
    gradient: "from-purple-500 to-pink-500",
  },
  {
    title: "MOTTO",
    desc: "Building smart digital solutions for a better tomorrow.",
    icon: <FaLightbulb className="w-16 h-16 text-white" />,
    gradient: "from-orange-500 to-red-500",
  },
];